import moment from 'moment-timezone';

import React, {
  useState,
  cloneElement,
} from 'react';
import styled from 'styled-components';
// import moment from 'moment-timezone';

import AntdModal from 'antd/lib/modal';

import InitialSelect from 'hive-admin/src/components/Input/Select';

import POS from '../../components/POS';

import { getScheduledOrderDue } from '../../components/Links';

import Types from '../../modules/types';

import { getViewerSpecificRole } from '../../helpers/library';
import clickAnchor from '../../helpers/clickAnchor';

import {
  getServerUrl,
} from '../../helpers/copyToClipboard';

import { DownloadAirWayBill } from './AirWayBill';

const isNotPackmanShopShippingProvider = props => (
  !props.data.shipping
  || ![ShippingProvider.PACKMAN_SHOP].includes(
        props.data.shipping.provider,
      )
);

const Select = styled(props => <InitialSelect {...props} open={false} />)`

`;

const getShippingStatusUpdateRequestConfig = (
  status,
  transform = config => config,
) => props => transform(
  {
    url: `orders/shipping/${
      props.data.shipping.provider.toLowerCase().replace(/_/g, '-')
    }?manual=true&id=${
      props.data._id
    }`,
    data: { orderStatus: status },
    method: 'POST',
  },
  props,
);

const {
  CONSTANTS: {
    OrderStatus,
    ShippingProvider,
  },
} = Types;

const orderHasNoAction = actionName => props => (
  !props.data
  || !props.data.actions
  || props.data.actions.findIndex(action => action.name === actionName) === -1
);

const orderIsNotPOSDraft = props => (
  !props.data
  || props.data.status !== 'DRAFT'
  || props.data.draftPurpose !== 'POS'
);

export const actionApprove = ['ActionWithRequest', {
  name: 'approve',
  title: 'Approve',
  skip: [orderHasNoAction('APPROVE')],
  getRequestConfig: props => ({
    url: `orders/${props.data._id}/approval`,
    data: { success: true },
    method: 'POST',
  }),
  handleSuccess: (data, props) => props.reload(),
}];

export const actionDeny = ['ActionWithRequest', {
  name: 'deny',
  title: 'Deny',
  type: 'danger', // TODO decide if to keep
  disabled: [() => false],
  skip: [orderHasNoAction('DENY')],
  getRequestConfig: props => ({
    url: `orders/${props.data._id}/approval`,
    data: { success: false },
    method: 'POST',
  }),
  handleSuccess: (data, props) => props.reload(),
}];

export const actionReadyForPickup = ['ActionWithRequest', {
  name: 'readyForPickup',
  title: 'Ready For Pickup',
  skip: [orderHasNoAction('READY')],
  getRequestConfig: props => ({
    url: `orders/${props.data._id}/ready`,
    data: { ready: true },
    method: 'POST',
  }),
  // eslint-disable-next-line no-unused-vars
  popconfirm: (props, action) => {
    if (props.data?.shipping?.scheduled) {
      return {
        title: (
          <div>
            This order is scheduled to be shipped out
            {` ${getScheduledOrderDue(props.data)}.`}
            <br />
            Pressing OK will make it available for pickup right now,
            <br />
            ignoring the scheduled date set by the customer.
            <br />
            Do you wish to proceed?
          </div>
        ),
      };
    }
    return null;
  },
  handleSuccess: (data, props) => props.reload(),
}];

export const actionSent = ['ActionWithFormModal', {
  name: 'sent',
  title: 'Processing',
  fields: [
    ['FieldText', {
      name: 'trackingId',
      label: null,
      prefix: 'Tracking ID:',
    }],
    ['FieldText', {
      name: 'trackingUrl',
      label: null,
      prefix: 'Tracking URL:',
    }],
    ['FieldText', {
      name: 'referenceId',
      label: null,
      prefix: 'Reference ID:',
      skip: [isNotPackmanShopShippingProvider],
    }],
    ['FieldText', {
      name: 'referenceCode',
      label: null,
      prefix: 'Reference Code:',
      placeholder: 'Barcode / QRCode',
      skip: [isNotPackmanShopShippingProvider],
    }],
    ['FieldConnectionSelect', {
      name: 'shippingCompany',
      // label: 'Shipping Company:',
      label: null,
      prefix: 'Shipping Company:',
      url: '/shippingcompanies',
      // placeholder: 'search by name',
      allowClear: true,
      searchPaths: ['name'],
      extraQueryProps: { populateStoreName: true },
      getInitialValue: (field, props) => {
        const value = (
          props.data.shipping?.company?._id
          || props.data.shipping?.company
        );
        return value || null;
      },
      // skip: [isNotPackmanShopShippingProvider],
    }],
  ],
  skip: [orderHasNoAction('SENT')],
  actions: [
    ['ActionWithRequest', {
      name: 'sent-confirm',
      title: 'Set As Processing',
      getRequestConfig: getShippingStatusUpdateRequestConfig(
        'DELIVERING',
        (requestConfig, props) => ({
          ...requestConfig,
          data: {
            ...(requestConfig.data || {}),
            ...props.form.getFieldsValue(),
          },
        }),
      ),
      handleSuccess: (data, props) => props.reload(),
    }],
  ],
}];

export const actionSetShippingCompany = ['ActionWithFormModal', {
  name: 'set-shipping-company',
  title: 'Set Shipping Company',
  fields: [
    ['FieldConnectionSelect', {
      name: 'shippingCompany',
      // label: 'Shipping Company:',
      label: null,
      prefix: 'Shipping Company:',
      url: '/shippingcompanies',
      // placeholder: 'search by name',
      allowClear: true,
      searchPaths: ['name'],
      getInitialValue: (field, props) => {
        const value = (
          props.data.shipping?.company?._id
          || props.data.shipping?.company
        );
        return value || null;
      },
      skip: [
        props => (
             !props.data
          || !props.data.shipping
          || ![ShippingProvider.PACKMAN_SHOP].includes(
                props.data.shipping.provider,
              )
        ),
      ],
    }],
  ],
  skip: [orderHasNoAction('SETSHIPPINGCOMPANY')],
  actions: [
    ['ActionWithRequest', {
      name: 'confirm-set-shipping-company',
      title: 'Confirm',
      getRequestConfig: props => ({
        url: `orders/${props.data._id}/shipping-company-set`,
        data: props.form.getFieldsValue(),
        method: 'POST',
      }),
      handleSuccess: (data, props) => props.reload(),
    }],
  ],
}];

export const actionFail = ['ActionWithRequest', {
  name: 'fail',
  title: 'Delivery Failed',
  popconfirm: {
    title: (
      <div>
        Press OK to fail the order delivery.
      </div>
    ),
  },
  skip: [orderHasNoAction('FAIL')],
  getRequestConfig: getShippingStatusUpdateRequestConfig('FAILED'),
  handleSuccess: (data, props) => props.reload(),
}];

export const actionDeliver = ['ActionWithRequest', {
  name: 'deliver',
  title: 'Delivery Success',
  popconfirm: {
    title: (
      <div>
        Press OK to report the order as delivered.
      </div>
    ),
  },
  skip: [orderHasNoAction('DELIVER')],
  getRequestConfig: getShippingStatusUpdateRequestConfig('DELIVERED'),
  handleSuccess: (data, props) => props.reload(),
}];

export const actionRestock = ['ActionWithRequest', {
  name: 'restock',
  title: 'Restock',
  popconfirm: {
    title: (
      <div>
        Press OK only if the order was already returned
        <br />
        and it&apos;s stock is now available!
      </div>
    ),
  },
  skip: [orderHasNoAction('RESTOCK')],
  getRequestConfig: props => ({
    url: `orders/${props.data._id}/restock`,
    data: {},
    method: 'POST',
  }),
  handleSuccess: (data, props) => props.reload(),
}];

export const actionRefund = ['ActionWithRequest', {
  name: 'refund',
  title: 'Refund',
  popconfirm: {
    title: (
      <div>
        Pressing OK will refund the full order
        <br />
        amount to the customer!
      </div>
    ),
  },
  skip: [orderHasNoAction('REFUND')],
  getRequestConfig: props => ({
    url: `orders/${props.data._id}/refund`,
    data: {},
    method: 'POST',
  }),
  handleSuccess: (data, props) => props.reload(),
}];

export const actionReorder = ['ActionWithRequest', {
  name: 'reorder',
  title: 'Reorder',
  popconfirm: {
    title: (
      <div>
        Pressing OK will resubmit the order
        <br />
        to the shipping provider.
        <br />
        Make sure order has been returned first and
        <br />
        that the store has sufficient stock.
      </div>
    ),
  },
  skip: [orderHasNoAction('REORDER')],
  getRequestConfig: props => ({
    url: `orders/submit?reorder=${props.data._id}`,
    data: {},
    method: 'POST',
  }),
  processAction: props => (
    props.issueRequest(
      props,
      props.getRequestConfig(props),
    )
    .then(response => response.data)
    .then((data) => {
      if (!data || data.status !== OrderStatus.NEW) {
        throw new Error(
          `Could not reorder: "${
            data && data.message
            ? data.message
            : 'Internal Error'
          }"`,
        );
      }
      return data;
    })
  ),
  handleSuccess: (data, props) => {
    const specificRole = getViewerSpecificRole(props);
    const ordersPath = (
        specificRole === 'ADMIN'
      ? '/orders'
      : specificRole === 'SELLER'
      ? '/store/orders'
      : ''
    );
    props.history.replace(
      `${ordersPath}/${data._id}`,
    );
  },
}];

export const actionDevForceCapturePayment = ['ActionWithRequest', {
  name: 'dev-force-capture-payment',
  title: 'Force Capture Payment (dev)',
  skip: [orderHasNoAction('DEV/PAYTABS/FORCE_CAPTURE_PAYMENT')],
  getRequestConfig: props => ({
    url: `orders/${props.data._id}/dev/paytabs/force-capture-payment`,
    data: {},
    method: 'POST',
  }),
  handleSuccess: (data, props) => props.reload(),
}];

export const actionSendOrderLink = ['ActionWithFormModal', {
  name: 'send-order-link',
  title: 'Send Order Link',
  fields: [
    ['FieldSelect', {
      name: 'to',
      label: null,
      prefix: 'To:',
      mode: 'tags',
      // eslint-disable-next-line max-len
      placeholder: 'International phone numbers (+971...) separated by space',
      tokenSeparators: [' '],
      Component: Select,
    }],
  ],
  actions: [
    ['ActionWithRequest', {
      name: 'send-sms',
      title: 'Send SMS ',
      skip: [],
      getRequestConfig: props => ({
        url: `orders/${props.data._id}/sendsms`,
        method: 'POST',
        data: props.form.getFieldsValue(),
      }),
    }],
    ['Action', {
      name: 'send-whatsapp',
      title: 'Send WhatsApp',
      skip: [],
      onClick: (props) => {
        const [number] = props.form.getFieldValue('to') || [];
        if (number) {
          clickAnchor({
            url: 'https://api.whatsapp.com/send',
            query: {
              phone: number,
              text: `Packman Order Link: ${
                getServerUrl()
              }/order/${
                props.data._id
              }`,
            },
          });
        }
      },
    }],
  ],
}];

export const actionUpdateStatus = ['ActionWithFormModal', {
  name: 'update-status',
  title: 'Force Update Status',
  type: 'danger',
  skip: [orderHasNoAction('UPDATE_STATUS_ADMIN')],
  fields: [
    ['FieldReact', {
      name: 'Info',
      renderContent: () => (
        <div>
          <p>
            <strong>Warning:</strong>
            {' '}
            This action will not send any emails
             or update the stock of the store. Use with caution.
          </p>
        </div>
      ),
    }],
    ['FieldSelect', {
      name: 'statusNew',
      label: null,
      prefix: 'Status:',
      // eslint-disable-next-line max-len
      placeholder: 'Select order status',
      choices: [
        // OrderStatus.INVALID,
        OrderStatus.NEW,
        OrderStatus.DELIVERY,
        OrderStatus.DELIVERED,
        OrderStatus.FAILED,
      ].map(status => ({
        value: status,
        label: Types.ORDER_STATUS_LABELS_MAP[status],
      })),
    }],
  ],
  actions: [
    ['ActionWithRequest', {
      name: 'update-status',
      title: 'Force Update',
      skip: [],
      handleSuccess: (data, props) => props.reload(),
      getRequestConfig: props => ({
        url: `orders/${props.data._id}/update-status-admin`,
        method: 'POST',
        data: props.form.getFieldsValue(),
      }),
    }],
  ],
}];

export const actionDownloadAWB = ['Action', {
  name: 'download-sticker',
  title: 'Download AWB',
  skip: [orderHasNoAction('DOWNLOAD_AIRWAYBILL')],
  renderAction: (props, action) => {
    const { data: order } = props;
    const { currency } = Types.getSystemCountry(order.systemCountry);
    return (
      <DownloadAirWayBill
        orderNumber={order._id}
        orderDate={moment(order.createdAt).format('llll')}
        orderItems={order.items.map(item => `${
          item.quantity
        }x ${
          item.name
        }`)}
        cod={(
          order.cost.cod > 0
          ? `${currency} ${Types.decimalize(order.cost.cod)}`
          : null
        )}
        from={[
          order.store.name,
          order.pickupDetails.address.line1,
          order.pickupDetails.address.line2,
          order.pickupDetails.phoneNumberString,
        ]}
        to={[
          order.shippingDetails.name,
          order.shippingDetails.address.line1,
          order.shippingDetails.address.line2,
          order.shippingDetails.phoneNumberString,
        ]}
        shippingProvider={order.shipping.company?.name}
        referenceId={order.shipping.referenceId}
        referenceCode={order.shipping.referenceCode}
        // Optional
        mode="color" // or "bw"
        fileName={`Air Waybill (${order._id}).pdf`}
      >
        {
          ({ loading }) => (
            loading
            ? action.renderAction({
                ...props,
                title: 'Loading...',
                disabled: true,
              })
            : action.renderAction(props)
          )
        }
      </DownloadAirWayBill>
    );
  },
}];

const ModalHTML = ({ className, ...props }) => (
  <AntdModal wrapClassName={className} {...props} />
);

const Modal = styled(ModalHTML)`
  .ant-modal {
    width: 100% !important;
    max-width: 580px !important;
    padding: 10px;
  }

  .ant-modal-footer,
  .ant-modal-header {
    display: none;
  }

  .ant-modal-content {
    // TODO: apply theme border-radius
    border-radius: 20px;
    box-shadow: 0 0 20px hsla(0, 0%, 0%, 0.07);
    margin-top: 400px;
  }

  .ant-modal-close-x {
    opacity: 0.5;
  }
`;

function ShowOrderQrCodeAction({ actionProps, actionInstance }) {
  const { data: order } = actionProps;
  const { store } = order;
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      {
        cloneElement(actionInstance.renderAction(actionProps), {
          onClick: () => setIsVisible(true),
        })
      }
      <Modal
        title="Order QR Code"
        visible={isVisible}
        okText={null}
        mask
        centered
        onOk={null}
        onCancel={() => setIsVisible(false)}
        maskStyle={{ background: store.posBackgroundColor || '#fff' }}
      >
        <POS store={store} order={order} />
      </Modal>
    </>
  );
}

export const actionShowQrCode = ['Action', {
  name: 'show-order-qr-code',
  title: 'Show QR Code',
  skip: [orderIsNotPOSDraft],
  renderAction: (props, instance) => (
    <ShowOrderQrCodeAction
      actionProps={props}
      actionInstance={instance}
    />
  ),
}];

export const actionShowOnPosOutlet = ['ActionWithRequest', {
  name: 'show-on-pos-outlet',
  title: 'Show On POS Outlet',
  skip: [orderIsNotPOSDraft],
  getRequestConfig: props => ({
    url: `orders/posoutlet?id=${props.data._id}`,
    method: 'POST',
  }),
}];

export const actionSaveAdminNote = ['ActionWithRequest', {
  name: 'save-admin-note',
  title: 'Save Note',
  icon: 'save',
  primary: true,
  skip: [
    props => !props.viewer || props.viewer.role !== 'ADMIN',
  ],
  getRequestConfig: props => ({
    url: `orders/${props.data._id}`,
    method: 'PATCH',
    data: {
      adminNote: props.form?.getFieldValue('adminNote'),
    },
  }),
  handleSuccess: (data, props) => {
    props.message.success('Admin note saved successfully');
    if (props.onRefresh) {
      props.onRefresh();
    }
  },
}];

export const ACTIONS = [
  actionApprove,
  actionDeny,
  actionReadyForPickup,
  actionSetShippingCompany,
  actionSent,
  actionFail,
  actionDeliver,
  actionRestock,
  actionRefund,
  actionReorder,
  actionDevForceCapturePayment,
  actionSendOrderLink,
  actionShowQrCode,
];

export const ADMIN = [
  actionSaveAdminNote, // Save Note button comes first for easy access
  ...ACTIONS,
  actionDownloadAWB,
  actionUpdateStatus,
];

export const SELLER_MERCHANT = [
  ...ACTIONS,
  actionShowOnPosOutlet,
  actionDownloadAWB,
];

export const SELLER_REFERRAL = [

];

export const SELLER_RESELLER = [

];
